import registry from "~/components/DoRegistry.js";
import template from "./flashMsg.hbs";

//initiallize things
$(document).ready(function(){
    if(!$('#doFlashWrapper').length) {
        $('#content').prepend('<div id="doFlashWrapper" class="ML2 MR2" style="display:none"></div>');
    }
});

let getStatusInfo = function(status){
    switch(status.toUpperCase()){
        case "SUCCESS": return {icon: "fa fa-check-circle-o", status: "confirm"};
        case "ERROR"  : return {icon: "fa fa-times-circle-o", status: "error"};
        case "WARN"   : return {icon: "fa fa-exclamation-circle", status: "important"};
        default       : return {icon: "fa fa-info-circle", status: "info"};
    }
};

class DoFlash {
    constructor($target, single){
        this.$target = $target || $('doFlashWrapper');
        this.single = single;
    }

    flash(status, msg, details){
        let $html = $(template({status: getStatusInfo(status), message:msg, details: details}));
        if(this.single){
            this.$target.html($html).show();
        }else{
            this.$target.prepend($html).show();
        }

        $html.find('.closeResult').click(()=>{$html.remove();});
    }
}

registry.register(__filename, DoFlash);
export default DoFlash;